export enum MapConnectSettings {
  ConnectedInRealTime = 'ConnectedInRealTime',
  ConnectedWithApproval = 'ConnectedWithApproval',
  Disconnected = 'Disconnected'
}
